import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { IoAddCircle } from "react-icons/io5";

function EmpSubscriptionPage() {
    const navigate = useNavigate();
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSubscriptions = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/admin/getAll_Subscription`);
            if (response.data.status === 200) {
                setSubscriptions(response.data.data); 
            }
        } catch (error) {
            console.error("Failed to fetch subscriptions", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubscriptions();
    }, []);

    useEffect(() => {
        let dataTable = null;
        if (!loading && subscriptions.length > 0) {
            const $ = window.$;
            // Destroy existing DataTable if it exists
            if ($.fn.DataTable.isDataTable('#subscription_table')) {
                $('#subscription_table').DataTable().destroy();
            }

            // Initialize new DataTable
            dataTable = $('#subscription_table').DataTable({
                responsive: true,
                searching: true,
                ordering: true,
                paging: true,
                pageLength: 10,
                destroy: true,
                autoWidth: false,
                dom: 'Bfrtip',
                language: {
                    search: "Search:",
                    searchPlaceholder: "Search subscriptions...",
                    emptyTable: "No subscriptions available",
                    zeroRecords: "No matching subscriptions found"
                },
                columnDefs: [
                    { orderable: false, targets: [6] }, // Disable sorting for Actions column
                    { searchable: false, targets: [6] } // Disable searching for Actions column
                ],
                order: [[0, 'asc']], // Sort by Package Name by default
                drawCallback: function() {
                    // Reinitialize tooltips after table draw
                    $('[data-bs-toggle="tooltip"]').tooltip();
                }
            });
        }

        // Cleanup function
        return () => {
            if (dataTable) {
                dataTable.destroy();
            }
        };
    }, [loading, subscriptions]);

    // const handleDelete = (id) => {
    //     const confirmDelete = window.confirm("Are you sure you want to delete this subscription?");
    //     if (confirmDelete) {
    //         setSubscriptions(prev => prev.filter(item => item.id !== id));
    //     }
    // };
    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this subscription?");
        if (!confirmDelete) return;

        try {
            const response = await axiosInstance.delete(`${API_URL}/admin/delete_Subscription/${id}`);
            if (response.data.status === 200) {
                alert("Subscription deleted successfully!");
                fetchSubscriptions(); 
            } else {
                alert("Failed to delete subscription.");
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("Something went wrong!");
        }
    };
    const handleEdit = async (id) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/admin/getSubscription/${id}`);
            if (response.data.status === 200) {
                const subscriptionData = response.data.data;
                navigate("/employer/subscription-edit", {
                    state: { subscription: subscriptionData }
                });
            } else {
                alert("Failed to fetch subscription details.");
            }
        } catch (error) {
            console.error("Error fetching subscription detail", error);
            alert("Something went wrong!");
        }
    };

    const handleAdd = () => {
        navigate('/employer/subscription-add');
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Subscription</h2>
                <div className="breadcrumbs">
                    <a href="#">Home</a> <a href="#">Dashboard</a> <span>Subscription</span>
                </div>
            </div>
            <div className="panel panel-default site-bg-white m-t30">
                <div className="panel-heading wt-panel-heading p-a20 d-flex justify-content-between align-items-center">
                    <h4 className="panel-tittle m-a0">
                        <i className="fa fa-suitcase" /> Subscription
                    </h4>
                    {/* <div className="text-left">
                        <button onClick={handleAdd} type="submit" className="site-button m-r5">Add Subscription</button>
                    </div> */}
                </div>
                <div className="panel-body wt-panel-body">
                    <div className="p-a20 table-responsive">
                        <table id="subscription_table" className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Package Name</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                    <th>Time</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loading && subscriptions.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <a href="#" className="site-text-primary">{item.title || 'N/A'}</a>
                                        </td>
                                        <td>{item.description || 'N/A'}</td>
                                        <td>{item.price || 'N/A'}</td>
                                        <td>{item.time || 'N/A'}</td>
                                        <td>{item.type || 'N/A'}</td>
                                        <td>
                                            <span className={`badge ${item.status === "active" ? "bg-success" : "bg-danger"}`}>
                                                {item.status || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="twm-table-controls">
                                                <ul className="twm-DT-controls-icon list-unstyled">
                                                    <li>
                                                        <button 
                                                            title="Edit" 
                                                            data-bs-toggle="tooltip" 
                                                            data-bs-placement="top"
                                                            onClick={() => handleEdit(item.id)}
                                                            className="btn btn-sm"
                                                        >
                                                            <span className="far fa-edit" />
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Package Name</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                    <th>Time</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </tfoot>

                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmpSubscriptionPage;































// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// function EmpSubscriptionPage() {
//     const navigate = useNavigate();

//     const [subscriptions, setSubscriptions] = useState([
//         { name: "Basic", sr: "#552030", transaction: "#HDAC-101512012", jobs: 20, used: 14, remain: 6, status: "Active", expired: "13/06/2023" },
//         { name: "Premium", sr: "#552045", transaction: "#ICIC-101512023", jobs: 35, used: 25, remain: 10, status: "Active", expired: "15/06/2023" },
//         { name: "Gold", sr: "#552050", transaction: "#AXY-101512050", jobs: 28, used: 24, remain: 4, status: "Expired", expired: "17/06/2023" },
//         { name: "Basic", sr: "#552055", transaction: "#SBI-101512056", jobs: 22, used: 14, remain: 8, status: "Active", expired: "25/06/2023" },
//         { name: "Gold", sr: "#552060", transaction: "#HDAC-1015123552", jobs: 18, used: 14, remain: 4, status: "Active", expired: "15/05/2023" },
//         { name: "Basic", sr: "#552075", transaction: "#HDAC-1015121503", jobs: 20, used: 14, remain: 6, status: "Expired", expired: "08/05/2023" }
//     ]);

//     const handleDelete = (sr) => {
//         const confirmDelete = window.confirm("Are you sure you want to delete this subscription?");
//         if (confirmDelete) {
//             setSubscriptions(subscriptions.filter(item => item.sr !== sr));
//         }
//     };

//     return (
//         <>
//             <div className="wt-admin-right-page-header clearfix">
//                 <h2>Subscription</h2>
//                 <div className="breadcrumbs">
//                     <a href="#">Home</a> <a href="#">Dashboard</a> <span>Subscription</span>
//                 </div>
//             </div>
//             <div className="panel panel-default site-bg-white m-t30">
//                 <div className="panel-heading wt-panel-heading p-a20">
//                     <h4 className="panel-tittle m-a0">
//                         <i className="fa fa-suitcase" /> Subscription
//                     </h4>
//                 </div>
//                 <div className="panel-body wt-panel-body">
//                     <div className="p-a20 table-responsive">
//                         <table className="table twm-table table-striped table-borderless">
//                             <thead>
//                                 <tr>
//                                     <th>Package Name</th>
//                                     <th>Sr. Number</th>
//                                     <th>Transaction ID</th>
//                                     <th>No. of Jobs</th>
//                                     <th>Used</th>
//                                     <th>Remain</th>
//                                     <th>Status</th>
//                                     <th>Expired</th>
//                                     <th>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {subscriptions.map((item, index) => (
//                                     <tr key={index}>
//                                         <td>
//                                             <a href="#" className="site-text-primary">{item.name}</a>
//                                         </td>
//                                         <td>{item.sr}</td>
//                                         <td>{item.transaction}</td>
//                                         <td>{item.jobs}</td>
//                                         <td>{item.used}</td>
//                                         <td>{item.remain}</td>
//                                         <td>
//                                             <span className={item.status === "Active" ? "text-clr-green2" : "text-clr-red"}>
//                                                 {item.status}
//                                             </span>
//                                         </td>
//                                         <td>{item.expired}</td>
//                                         <td>
//                                             <div className="twm-table-controls">
//                                                 <ul className="twm-DT-controls-icon list-unstyled">
//                                                     <li>
//                                                         <button title="Edit" data-bs-toggle="tooltip" data-bs-placement="top"
//                                                             onClick={() => navigate("/employer/subscription-edit")}>
//                                                             <span className="far fa-edit" />
//                                                         </button>
//                                                     </li>
//                                                     <li>
//                                                         <button title="Delete" data-bs-toggle="tooltip" data-bs-placement="top"
//                                                             onClick={() => handleDelete(item.sr)}>
//                                                             <span className="far fa-trash-alt" />
//                                                         </button>
//                                                     </li>
//                                                 </ul>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))}
//                                 {subscriptions.length === 0 && (
//                                     <tr>
//                                         <td colSpan="9" className="text-center">No subscriptions available.</td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default EmpSubscriptionPage;
